import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@skatteetaten/ds-buttons';
import { dsI18n } from '@skatteetaten/ds-core-utils';
import { HelpSimpleSVGpath, CancelSVGpath } from '@skatteetaten/ds-icons';
import './styles.css';


var styles = {
    "description": "Help-module_description__WZ443",
    "descriptionMarginTop": "Help-module_descriptionMarginTop__A6SEh",
    "helpButton": "Help-module_helpButton__vqGaM",
    "helpBox": "Help-module_helpBox__XvQii",
    "helpBoxText": "Help-module_helpBoxText__k4rrJ",
    "helpBoxCloseButton": "Help-module_helpBoxCloseButton__-dgnC",
    "srOnly": "Help-module_srOnly__mv9Tu"
};

const Help = ({ description, helpText, helpSvgPath, hideHelp, targetId, titleHelpSvg, onHelpToggle, className, classNames })=>{
    const { t } = useTranslation('Shared', {
        i18n: dsI18n
    });
    const [showHelpText, setShowHelpText] = useState(false);
    const helpButtonRef = useRef(null);
    const svgHelpIcon = helpSvgPath ?? HelpSimpleSVGpath;
    const titleHelpIcon = titleHelpSvg ?? t('shared.Help');
    const toggleHelpText = ()=>{
        onHelpToggle?.(!showHelpText);
        setShowHelpText(!showHelpText);
    };
    const closeHelpText = ()=>{
        setShowHelpText(false);
        helpButtonRef.current?.focus();
        onHelpToggle?.(false);
    };
    const marginTopClassName = showHelpText ? styles.descriptionMarginTop : '';
    const hideHelpClassName = hideHelp ? styles.srOnly : '';
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            helpText && /*#__PURE__*/ jsx(IconButton, {
                ref: helpButtonRef,
                className: `${styles.helpButton} ${hideHelpClassName}`.trim(),
                svgPath: svgHelpIcon,
                title: titleHelpIcon,
                size: 'extraSmall',
                ariaExpanded: showHelpText,
                ariaDescribedby: targetId,
                isOutlined: true,
                onClick: ()=>toggleHelpText()
            }),
            helpText && showHelpText && /*#__PURE__*/ jsxs("div", {
                className: `${styles.helpBox} ${hideHelpClassName} ${className ?? ''} ${classNames?.helpText ?? ''}`.trim(),
                children: [
                    /*#__PURE__*/ jsx("span", {
                        className: styles.helpBoxText,
                        children: helpText
                    }),
                    /*#__PURE__*/ jsx(IconButton, {
                        className: styles.helpBoxCloseButton,
                        size: 'small',
                        svgPath: CancelSVGpath,
                        title: t('shared.Close'),
                        onClick: ()=>closeHelpText()
                    })
                ]
            }),
            description && /*#__PURE__*/ jsx("div", {
                className: `${styles.description} ${marginTopClassName} ${hideHelpClassName} ${classNames?.description ?? ''}`.trim(),
                children: description
            })
        ]
    });
};
Help.displayName = 'Help';

export { Help };
